import { BookOpen, CalendarDays, Heart, ListChecks, Sparkles } from "lucide-react";

const features = [
  { icon: CalendarDays, text: "Islamischer Kalender 1447 – 1448 AH" },
  { icon: BookOpen, text: "Qur’an Lesen & Ramadan-Tracker" },
  { icon: ListChecks, text: "Ziele, Gewohnheiten & Tagesplanung" },
  { icon: Heart, text: "Duas, Reflexion & Dankbarkeitsseiten" },
];

export default function FeaturedPlanner() {
  return (
    <section id="planner" className="relative overflow-hidden bg-cream-50 py-24 md:py-32 px-6">
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-clay-500/25 to-transparent" />
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal">
          <p className="section-kicker mb-6">Signature Planner · Bald erhältlich</p>

          <h2 className="font-serif text-5xl md:text-6xl text-ink-900 leading-[1.02] tracking-tight">
            Dar al Midad <br />
            <span className="italic text-mauve-500">Iman Planner</span>
          </h2>

          <p className="mt-8 text-lg leading-8 text-ink-700 max-w-xl font-light">
            Ein liebevoll gestalteter islamischer Planer für Fokus, Reflexion und
            die Stärkung deines Imans. Entwickelt, um deine Tage mit Sinn,
            Dankbarkeit und Klarheit zu planen.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {features.map(({ icon: Icon, text }) => (
              <div key={text} className="premium-card flex gap-4 items-start p-5">
                <Icon className="text-mauve-500 shrink-0" size={22} strokeWidth={1.4} />
                <p className="text-sm leading-relaxed text-ink-700 font-light">{text}</p>
              </div>
            ))}
          </div>

          <a
            href="https://wa.me/4915229516378?text=Assalamu%20Alaikum%2C%20ich%20m%C3%B6chte%20benachrichtigt%20werden%2C%20wenn%20der%20Dar%20al%20Midad%20Planer%20ver%C3%B6ffentlicht%20wird."
            target="_blank"
            rel="noopener noreferrer"
            className="premium-button inline-flex mt-10 items-center gap-3"
          >
            Als Erste:r informiert werden →
          </a>
        </div>

        <div className="relative reveal">
          <div className="absolute -inset-6 rounded-[2rem] bg-gradient-to-br from-mauve-400/20 via-white/40 to-clay-500/10 blur-2xl" />
          <div className="relative premium-card p-4 md:p-6 luxury-shadow">
            <div className="overflow-hidden rounded-[1.75rem] bg-cream-100">
              <img
                src="/products/planner-cover.png"
                alt="Dar al Midad Planner"
                className="w-full object-cover transition-transform duration-700 ease-out hover:scale-[1.03]"
              />
            </div>
          </div>

          <div className="absolute -top-5 -right-3 md:-right-8 bg-cream-50/90 border border-white/80 rounded-full h-32 w-32 flex items-center justify-center text-center text-[10px] tracking-[0.18em] uppercase text-ink-700 shadow-[0_20px_45px_-30px_rgba(44,39,36,0.7)] backdrop-blur">
            <Sparkles size={14} className="absolute top-7 text-mauve-500" />
            <span className="pt-4">Mit Liebe <br /> & Sorgfalt <br /> gefertigt</span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-20 grid md:grid-cols-3 gap-6">
        {["planner-monthly.png", "planner-daily.png", "planner-extra-pages.png"].map((img, index) => (
          <div key={img} className={`premium-card p-3 reveal ${index === 1 ? "md:mt-8" : ""}`}>
            <img
              src={`/products/${img}`}
              className="rounded-[1.25rem] shadow-sm transition-transform duration-700 ease-out hover:scale-[1.02]"
              alt="Planner preview page"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
